import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  Row,
  Col,
  Button,
  FormGroup,
  FormControl,
  ControlLabel,
  Checkbox,
  Alert,
  Tooltip
} from "react-bootstrap";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { bindActionCreators, compose } from "redux";
import { createBrowserHistory } from "history";
import { Breadcrumb as BreadcrumbComponent } from "../../../components";
import "../../../style/subAdmin/SubAdmin.scss";
import isEmpty from "lodash.isempty";

import {
  getSalesPersons,
  getSalesPersonQuestDetail,
  updateAnswer
} from "../../../redux/actions/salesPersonActions";
import { renderAlert, clearAlert } from "../../../redux/actions/alertsActions";
import loader from "../../../style/loader/loader.scss";

const history = createBrowserHistory();

let isLoading = "false",
  offerdata = {},
  userID = "";
class Add extends Component {
  static contextTypes = {
    router: PropTypes.object
  }
  constructor(props) {
    super(props);
    this.state = {
      questID: "",
      question: "",
      answer: "",
      path: ["Home", "Question", "Answer"],
      alertMessage: "",
      show: false,
      disabled: "",
      salespersonlist: []
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleDismiss = this.handleDismiss.bind(this);
    this.handleShow = this.handleShow.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.validate = this.validate.bind(this);
    this.Clear = this.Clear.bind(this);
  }

  handleDismiss() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  validate = () => {
    let isError = false;
    const errors = {};

    if (!this.state.answer) {
      isError = true;
      this.setState({ answerError: "red" });
    }

    return isError;
  };

  handleSubmit(e) {
    e.preventDefault();
    const err = this.validate();

    if (!err) {
      this.setState({ disabled: true });
      this.handleDismiss();
      this.handleShow();
      const postData = {
        quesID: this.state.quesID,
        answer: this.state.answer
      };
      this.props.updateAnswer(postData);
    }
  }

  handleChange(e) {
    this.setState({ qtyMessage: "" });
    if (`${e.target.name}Error` !== "") {
      this.setState({ [`${e.target.name}Error`]: "" });
    }
    this.setState({ [e.target.name]: e.target.value });
    this.setState({ disabled: false });
  }

  componentWillReceiveProps(nextProps) {
    if (
      this.props.salesPersonList !== nextProps.salesPersonList &&
      !isEmpty(nextProps.salesPersonList)
    ) {
      this.setState({ salespersonlist: nextProps.salesPersonList.data.data });
      isLoading = "false";
    }

    if (
      this.props.quesdetail !== nextProps.quesdetail &&
      !isEmpty(nextProps.quesdetail)
    ) {
      this.setState({
        offer: nextProps.quesdetail.data.dealText,
        merchant:
          nextProps.quesdetail.data.merchantFirstName +
          "" +
          nextProps.quesdetail.data.merchantLastName,
        salesperson:
          nextProps.quesdetail.data.salesFirstName +
          "" +
          nextProps.quesdetail.data.salesLastName,
        quesID: nextProps.quesdetail.data.quesID,
        question: nextProps.quesdetail.data.question
      });
      isLoading = "false";
    }

    if (
      this.props.answerResponse !== nextProps.answerResponse &&
      !isEmpty(nextProps.answerResponse)
    ) {
      this.props.clearAlert();
      this.handleShow();
      this.props.renderAlert("success", nextProps.answerResponse.message);
      this.setState({ disabled: false });
      isLoading = "false";
      this.Clear();
      isLoading = "false";
    }

    if (nextProps.message) {
      this.handleShow();
      this.setState({
        alertMessage: nextProps.message,
        msgType: nextProps.alertType
      });
      isLoading = "false";
    }

    if (this.props.error !== nextProps.error) {
      if (nextProps.error) {
        isLoading = "false";
        this.props.clearAlert();
        this.props.renderAlert("warning", nextProps.error);
      }
    }
  }

  Clear() {
    this.state.status = "";
    (this.state.note = ""), this.handleDismiss();
  }

  componentWillMount() {
    this.handleDismiss();
    this.props.clearAlert();

    let quesIdParams = this.props.match.params.quesID
      ? this.props.match.params.quesID
      : "";

    if (quesIdParams !== "") {
      isLoading = "true";
      this.props.getSalesPersonQuestDetail(quesIdParams);
    }
  }

  render() {
    let salesManagerItems;
    let salespersonData = this.state.salespersonlist
      ? this.state.salespersonlist
      : "";
    if (salespersonData !== "") {
      salesManagerItems = salespersonData.map((salesObject, index) => (
        <option key={index} value={salesObject.user_id}>
          {salesObject.userName}
        </option>
      ));
    }

    return (
      <div className="col-lg-12 add-sub-admin">
        {isLoading == "true" ? (
          <div className="loader">
            <p className="loading-message">
              <i>Loading...</i>
            </p>
            <div className="spinner">
              <div className="dot1" />
              <div className="dot2" />
            </div>
          </div>
        ) : (
          ""
        )}
        <form onSubmit={this.handleSubmit}>
          <div className="row">
            <div className="col-xs-12">
              <BreadcrumbComponent path={this.state.path} />
            </div>
          </div>
          <div className="panel">
            <header className="panel-heading">Answer Question</header>
            {this.state.show &&
              this.state.alertMessage !== "" && (
                <div className="col-lg-12">
                  <Alert
                    bsStyle={this.state.msgType}
                    onDismiss={this.handleDismiss}
                  >
                    <strong>{this.state.msgType}:</strong>{" "}
                    {this.state.alertMessage}
                  </Alert>
                </div>
              )}
            <div className="panel-body">
              <div className="add-city col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <Row>
                  <Col md={6} xs={12}>
                    <FormGroup controlId="formOffer">
                      <ControlLabel> {this.state.merchant} </ControlLabel>
                      <br />
                      <ControlLabel> {this.state.offer} </ControlLabel>
                    </FormGroup>

                    <FormGroup controlId="formDiscountAmount">
                      <ControlLabel>Question </ControlLabel>

                      <FormControl
                        componentClass="textarea"
                        value={this.state.question}
                        placeholder=""
                        onChange={this.handleChange}
                        name="question"
                      />
                    </FormGroup>
                  </Col>
                  <Col md={6} xs={12}>
                    <FormGroup controlId="formOffer">
                      <ControlLabel> Asked by </ControlLabel>
                      <br />
                      <ControlLabel> {this.state.salesperson} </ControlLabel>
                    </FormGroup>

                    <FormGroup controlId="formDiscountAmount">
                      <ControlLabel>Answer </ControlLabel>

                      <FormControl
                        componentClass="textarea"
                        value={this.state.answer}
                        placeholder=""
                        onChange={this.handleChange}
                        name="answer"
                        style={{ borderColor: this.state.answerError }}
                      />
                    </FormGroup>
                  </Col>
                </Row>
              </div>
            </div>
          </div>
          <Row className="BtnRow">
            <Col md={12} xs={12}>
              <Button
                bsStyle="info"
                type="submit"
                id="saveButton"
                disabled={this.state.disabled}
              >
                Answer Question{" "}
              </Button>

              <Button
                bsStyle="default"
                onClick={() => this.context.router.history.push(`/question/pending`)}
              >
                Cancel
              </Button>
            </Col>
          </Row>
        </form>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    alertType: state.alertsReducer.alertType,
    message: state.alertsReducer.message,
    error: state.salesPersonReducer.error,
    quesdetail: state.salesPersonReducer.quesdetail,
    salesPersonList: state.salesPersonReducer.salesPersonList,
    answerResponse: state.salesPersonReducer.answerResponse
  };
};

export default compose(
  withRouter, // IMPORTANT: witRouter is "needed here" to avoid blocking routing:
  connect(mapStateToProps, {
    getSalesPersons,
    getSalesPersonQuestDetail,
    updateAnswer,
    renderAlert,
    clearAlert
  })
)(Add);



// WEBPACK FOOTER //
// ./src/app/views/salesPerson/question/Add.js